// extracted by mini-css-extract-plugin
export var cell = "_6d-4";
export var headerCell = "_6d-2";
export var rowHeader = "_6d-3";
export var table = "_6d-1";
export var tableContainer = "_6d-0";